
import Headersection from './Component/HeaderTop/Headersection';
import Partners from './Component/Partners/Partners';
import '@fortawesome/fontawesome-free/css/all.min.css';
import One from './Component/One/One';
import Savings from './Component/Savings/Savings';
import Create from './Component/Create/Create';
import Trust from './Component/Trust/Trust';
import Pricing from './Component/Pricing/Pricing';
import TestimonialUpdate from './Component/TestimonialUpdate/TestimonialUpdate.jsx';
import Faqs from './Component/FAQ/Faqs';
import Footer from './Component/Footer/Footer';
import Plans from './Component/Plans/Plans';
import Upgrade from './Component/Upgrade/Upgrade';
import { Cards } from './Component/Cards/Cards';
import HowItWorks from './Component/Howitworks/Howitworks';
import UseCases from './Component/UseCases/UseCases';
import Comparison from './Component/Comparison/Comparison';
import { BrowserRouter as Router, Route, Routes,  } from "react-router-dom";
import Footerlink from './Component/FooterLink/Footerlink.jsx';
function App() {
  return (
    <Router basename="/smart-nfc-card">
      <Routes>
        <Route path="/" element={
          <div>
            <Headersection />
            <Partners />
            <Upgrade />
            <Comparison />
            <One />
            <Cards />
            <Create />
            <HowItWorks />
            <UseCases />
            <TestimonialUpdate />
            <Faqs />
            <Footer />
            <Footerlink />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
